// angular
//   .module("HeroPRO")
//   .directive("pipelineTable", PipelineTable);

export default function PipelineTable() {
    return {
        controller: 'PipelineTableController',
        controllerAs: 'pipelineTable',
        bindToController: true,
    	restrict: 'E',
    	scope: {
      		template: '@template', // string
      		source: '@source', // string
    	},
    	link(scope, element, attrs) {
      		scope.getContentUrl = function () {
        		return `app/pipeline/pipelineTable/${attrs.template}.html`;
      		};
    	},
    	template: '<div class="pipeline-scroll" ng-include="getContentUrl()"></div>',
    };
}



// WEBPACK FOOTER //
// ./src/app/pipeline/pipelineTable/pipelineTableDirective.js